import script from "./RfidPieceupLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidPieceupLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidPieceupLogsPage.vue?vue&type=style&index=0&id=3e6eba33&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6eba33"]])

export default __exports__